import { Box, Typography, TextField } from "@mui/material";

export default function AdditionalCommentsSection({ comments, setComments }) {
  return (
    <Box mb={4}>
      <Typography variant="h6" gutterBottom>
        Comentarios Adicionales
      </Typography>
      <TextField
        label="Escribí tus observaciones o comentarios aquí"
        value={comments}
        onChange={(e) => setComments(e.target.value)}
        multiline
        rows={4}
        fullWidth
        variant="outlined"
      />
    </Box>
  );
}